export async function fetchGroups() {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(process.env.REACT_APP_API + `/groups/`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}
